import MySavedItemsWidget from './MySavedItemsWidgetContainer';

export default MySavedItemsWidget;